<template>
  <TopBar :show-log-out="false"></TopBar>
  <div class="authentication-container">
    <router-view></router-view>
  </div>
</template>

<style>
.authentication-container {
  max-width: 470px;
  margin: 0 auto;
}
</style>
<script>
import TopBar from '@/components/TopbarElement';
export default {
  components: { TopBar },
};
</script>
